import React, { Component } from 'react';
import logo from "../images/zp-logo.svg";
import {
    Link,Redirect
  } from "react-router-dom";
  import {SelectWorkOrder} from './selectWOrkOrder';
  import {_workOrder} from './selectWOrkOrder';
  import { connect } from 'react-redux';
  import Login from './login/login'

  let showWorkorderComponent=false;


export class Header extends Component {
    constructor(props){
        super(props)
  this.state = {
    workOrder:"",
    showWorkorderComponent:false,
    loginDetails:""
  }
  this.getWorkOrderHandler=this.getWorkOrderHandler.bind(this);
  this.selectWorkorder=this.selectWorkorder.bind(this);
    }


    componentDidMount(){

    let loginDetails = localStorage.getItem("loginDetails");
    loginDetails = JSON.parse(loginDetails);

    let type = localStorage.getItem("type");
    if(type){
    type = JSON.parse(type);
    type=type.charAt(0);
    this.setState({
        loginDetails:loginDetails,
        type:type
    })
  }
    }


    getWorkOrderHandler(e) {
    //    e.preventDefault()
// this.setState({
//     workorder:e.targ
// })
    }
    selectWorkorder(e){
        this.setState({
            workOrder:"select"
        })
    }
    logout(e){
        localStorage.removeItem("workOrderObj");
        localStorage.removeItem("loginDetails");
        // window.location.reload()
    }

render(){
  console.log(this.state.loginDetails, "this.state.loginDetails====");

  let workOrder=localStorage.getItem("workOrderObj");
workOrder=JSON.parse(workOrder)
let work_order;
if(workOrder){
     work_order=workOrder.workOrder;
}

if(_workOrder!==work_order){
    var _workOrder=work_order;

}
if(this.props.location.pathname=='/'){
     showWorkorderComponent=true
}

    return(<>
        {/* {JSON.parse(localStorage.getItem("workOrderObj")) ?  */}
      {  this.props.location.pathname=='/' ?
       <Redirect to="/login" />
       :
        <div className='header'>
            {this.props.location.pathname=='/login' || this.props.location.pathname=='/selectWorkOrder' ? "" :
         <nav class="navbar navbar-expand-sm  navbar-light justify-content-end " id='nav-bar'>
         <img className="logo" src={logo} alt="Smiley face" />
    <a class="ml-auto mr-1" ></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent">
        <ul class="navbar-nav text-right">
            <li class="nav-item active " >
                <Link class="nav-link active"  href="#" id='item' to='/home'>Home</Link>
            </li>
            <li class="nav-item ">
                <Link class="nav-link" href="/map" id='item' to='/map'
                 onClick={() => {this.props.history.push('/map');
                //  window.location.reload()
                }}
                 >Map View</Link>
            </li>
            <li class="nav-item dropdown">
                {/* <Link class="nav-link" href="#" id="item" to='/ward'>Ward Report</Link> */}
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Reports
                </a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdown"
                >
                  {/* <Link to="ward">
                    <a
                      class="dropdown-item"
                      // onClick={this.selectWorkorder}
                      name="select"
                      href="#"
                    >
                      Ward Report
                    </a>
                  </Link> */}
                  <Link to="ward">
                    <a
                      class="dropdown-item"
                      // onClick={this.selectWorkorder}
                      name="select"
                      href="#"
                    >
                      Ward Report
                    </a>
                  </Link>
                  <Link to="agencyReport">
                    <a
                      class="dropdown-item"
                      // onClick={this.selectWorkorder}
                      name="select"
                      href="#"
                    >
                      Agency Report
                    </a>
                  </Link>
                  <Link to="userReport">
                    <a
                      class="dropdown-item"
                      // onClick={this.selectWorkorder}
                      name="select"
                      href="#"
                    >
                      User Report
                    </a>
                  </Link>
                </div>
            </li>
            <li class="nav-item ">
                <Link class="nav-link" href="#" id="item" to='/ulb'>ULB Report</Link>
            </li>
            <li class="nav-item ">
            <Link class="nav-link" href="#" id="item" to='/agency'>Agency</Link>
            </li>
            {this.state.loginDetails.user ?
  (this.state.loginDetails.user.user_type == "admin" || this.state.loginDetails.user.user_type == "CLNT_SUPERVISOR" ? (

                      <li
                        class="nav-item dropdown"
                        onClick={this.getWorkOrderHandler}
                      >
                        <a
                          class="nav-link dropdown-toggle"
                          href="#"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          ClientManagement
                        </a>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          <Link to="addClient">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Add Client
                            </a>
                          </Link>
                          <Link to="editClient">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Edit Client
                            </a>
                          </Link>
                          <Link to="listClients">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              List Clients
                            </a>
                          </Link>
                          <Link to="deleteClient">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Delete/Block Client
                            </a>
                          </Link>
                        </div>
                      </li>
                    ) : (
                      ""
                    )):""
                  }
{this.state.loginDetails.user ?
  (this.state.loginDetails.user.user_type == "admin" || this.state.loginDetails.user.user_type == "CLNT_SUPERVISOR" ? (

                      <li
                        class="nav-item dropdown"
                        onClick={this.getWorkOrderHandler}
                      >
                        <a
                          class="nav-link dropdown-toggle"
                          href="#"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          UserManagement
                        </a>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          <Link to="addUser">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Add User
                            </a>
                          </Link>
                          <Link to="editUser">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Edit User
                            </a>
                          </Link>
                          <Link to="listUsers">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              List Users
                            </a>
                          </Link>
                          <Link to="deleteUser">
                            <a
                              class="dropdown-item"
                              // onClick={this.selectWorkorder}
                              name="select"
                              href="#"
                            >
                              Delete/Block User
                            </a>
                          </Link>
                        </div>
                      </li>
                    ) : (
                      ""
                    )):""
                  }
            <li class="nav-item ">
            <Link class="nav-link" href="#" id="item" to='#'>{_workOrder}<small>({this.state.type})</small></Link>

            </li>

            <li class="nav-item dropdown" onClick={this.getWorkOrderHandler}>
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown"  role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Work Order
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" >

          <Link to='selectWorkOrder'>
          <a class="dropdown-item" onClick={this.selectWorkorder} name='select' href="#">
            Select
              </a>
              </Link>
          {/* <div class="dropdown-divider"></div> */}
          {/*  <a class="dropdown-item" value='NDMC' href="#">Create</a>*/}
        </div>
      </li>

      <li class="nav-item dropdown" >
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown"  role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
{this.state.loginDetails ?
(this.state.loginDetails.user.name ? this.state.loginDetails.user.name : "Profile")
   :"Profile."}

        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" style={{left: "-1em"}} >

        <Link to='login'>  <a class="dropdown-item" onClick={this.logout.bind(this)} name='select' href="#">
              Logout
              </a>
              </Link>
              </div>
              </li>

        </ul>
    </div>
</nav>
 }

        </div>

        }
        </>
    )
}


}




function mapStateToProps  (state){
   // ulbState: state
   return {home_state:state}
  }

  export default connect(
    mapStateToProps,
  )(Header)
